module.exports = __webpack_public_path__ + "static/img/viva_logo_ce.466251e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/art/viva_logo_ce.jpg
// module id = I4a9
// module chunks = 1